import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import TablaCalificacion from '../../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../../exportacion_react_pdf/TextAreaLabelGroup';
import TextAreaLabel from '../../../../exportacion_react_pdf/TextAreaLabel';

const secciones_pecuario = [
    {
        key: '1',
        title: '1. PLANIFICACION PREDIAL/MANEJO DE LA UNIDAD PRODUCTIVA',
        questions: [
            {
                section: '1.1',
                description: 'El/la productor/a  identifica  las varaibles de planificacion predial para su sistema productivo y cuenta con una programacion y planificacion (Inventarios, procesos, entradas, salidas de animales, proyeccion de ventas, etc?',
            },
            {
                section: '1.2',
                description: 'El/la productor/a reconoce la importancia de manejo de regsitros y lleva registros productivos, reproductivos sanitarios, de alimentacion, comerciales, de costos de produccion?',
            },
        ],
    },
    {
        key: '2',
        title: '2. COSTOS DE PRODUCCION ',
        questions: [
            {
                section: '2.1',
                description: 'El/la productor/a identifica las valiables o rubros asociados a sus costos de producccion y conoce los costos de su sistema productivo?',
            },
        ],
    },
    {
        key: '3',
        title: '3. INFRAESTRUCTURA PRODUCTIVA',
        questions: [
            {
                section: '3.1',
                description: 'El productor/a aplica prácticas para adaptación y mantenimiento de infraestructura para la producción pecuaria, con criterios de gestión del riesgo de desastres y bienestar animal ?',
            },
        ],
    },
    {
        key: '4',
        title: '4. PARÁMETROS PRODUCTIVOS',
        questions: [
            {
                section: '4.1',
                description: 'El/la productor/a conoce los parámetros productivos (ganancia de peso, conversion alimenticia, mortalidad, peso al destete, natalidad, etc) de acuerdo con el sistema de producción pecuaria (ganadería, porcicultura, avicultura, psicultura, etc)  implementado ?',
            }
        ],
    },

    {
        key: '5',
        title: '5. ALIMENTACIÓN Y NUTRICIÓN',
        questions: [
            {
                section: '5.1',
                description: 'El/la productor/a identifica las técnicas y prácticas de alimentación animal adecuadas para la especie (tipo de alimento, horas de suministro, cantidad, etc)',
            },
            {
                section: '5.2',
                description: 'El/la productor/a identifica las fuentes de alimentacion comerciales y alternativas de la zona, para los animales  (forraje, despedicios, concentrado, suero, residuos agroindustria, frutos y hojas de arboles, etc) ?',
            },
            {
                section: '5.3',
                description: 'El/la productor/a conoce las tecnicas de conservacion de forrajes para suminsitro a rumiantes (ensilaje, heno, henolaje)?',
            },
            {
                section: '5.4',
                description: 'El/la productor/a conoce las practicas de manejo de pasturas (sistemas silvopastoriles, division de potreros,  tiempos de ocupacion y descanso, renovacion, fertilizacion, etc.)',
            },
        ],
    },


    {
        key: '6',
        title: '6. MANEJO REPRODUCTIVO ',
        questions: [
            {
                section: '6.1',
                description: 'El/la productor/a implementa un manejo reproductivo adecuado para sus condiciones?',
            }

        ],
    },


    {
        key: '7',
        title: '7. SANIDAD Y BIOSEGURIDAD ANIMAL',
        questions: [
            {
                section: '7.1',
                description: 'El/la productor/a conoce las principales enfermedades que pueden afectar a los animales que cría y que tipo de tratamiento requiere?',
            },
            {
                section: '7.2',
                description: 'El/la productor/a implementa prácticas y técnicas para la prevención, tratamiento y atención de enfermedades?.',
            }

        ],
    },

    {
        key: '8',
        title: '8. BUENAS PRACTICAS PARA SISTEMA PRODUCTIVO',
        questions: [
            {
                section: '8.1',
                description: 'El/la productor/a reconoce e implementa las Buenas Practicas para la especie del sistema productivo ? ',
            },


        ],
    },

    {
        key: '9',
        title: '9. BUENAS PRACTICAS DE ORDEÑO',
        questions: [
            {
                section: '9.1',
                description: 'El/la productor/a reconoce e implementa las BPO para producir y comercializar leche de buena calidad higienica?',
            },


        ],
    },

    {
        key: '10',
        title: '10.PROTECCION DE ECOSISTEMAS, SALUD DEL SUELO Y MANEJO DE RESIDUOS   Y CUIDADO DEL AGUA',
        questions: [
            {
                section: '10.1',
                description: 'El/la productor/a reconoce estrategias para la conservacion de Bosques, nacimientos y fuentes de agua, humedales y sabanas? ',
            },
            {
                section: '10.2',
                description: 'El/la productor/a reconoce practicas de uso de abonos organicos, manejo regenerativo y  labranza sostenible para la salud del suelo?',
            },
            {
                section: '10.3',
                description: 'El/la productor/a reconoce la clasificacion de residuos organicos que produce y su manejo para beneficio de la finca?',
            },
            {
                section: '10.4',
                description: 'El /la productor/a reconoce los residuos peligrosos y conoce las practicas para su adecuada disposición?',
            },
            {
                section: '10.5',
                description: 'El/la productor/a reconoce practicas de cosecha de agua para epocas de sequia y su manejo?',
            },


        ],
    },
];
// Define el documento
const ExportPecuarioPaso7 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.title_1}>CAPACIDADES DE PECUARIA</Text>

            <TablaCalificacion evaluacion={formData?.capacidades_pecuario} secciones={secciones_pecuario}></TablaCalificacion>
        </View>

    </>
);

export default ExportPecuarioPaso7;